import React from "react";
import styles from "./CommonTable.module.scss";

export default function CommonTable({
  heading,
  tableHeadings,
  tableData,
  maxHeight,
}) {
  console.log(tableHeadings);
  return (
    <div className={styles.container}>
      <div className={styles.heading}>{heading}</div>
      <div className={styles.wrapper} style={{ maxHeight: maxHeight }}>
        <div className={styles.cardLabel}>
          {tableHeadings &&
            tableHeadings.map((item, i) => (
              <div className={styles.container} key={i}>
                {item}
              </div>
            ))}
        </div>
        {Array.from(Array(30), (e, i) => {
          return (
            <div className={styles.card} key={i}>
              <div className={styles.container}>1 Hogi</div>
              <div className={styles.container}>Pending</div>
              <div className={styles.container}>Deposit</div>
              <div className={styles.container}>April 29,2021,5:42:4 AM</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
